export default {
  meta: {
    title: '客流信息',
  },
};
